
// 教学相关接口
import request from '@/utils/request'

// 赛事类型----------------------------
// 赛事类型列表
export function typeList(query) {
  return request({
    url: '/biz/type/list',
    method: 'get',
    params: query
  })
}
// 新增赛事类型
export function addType(params) {
  return request({
    url: '/biz/type',
    method: 'post',
		data: params
  })
}
// 编辑赛事类型
export function editType(params) {
  return request({
    url: '/biz/type/edit',
    method: 'post',
		data: params
  })
}
// 删除赛事类型
export function delType(id) {
  return request({
    url: `/biz/type/${id}`,
    method: 'get',
  })
}

// 赛事类型列表
export function getTypes() {
  return request({
    url: '/biz/type/selectList',
    method: 'get',
  })
}

// 赛事项目----------------------------
// 赛事项目列表
export function projectList(query) {
  return request({
    url: '/biz/item/list',
    method: 'get',
    params: query
  })
}
// 新增赛事项目
export function addProject(params) {
  return request({
    url: '/biz/item',
    method: 'post',
		data: params
  })
}
// 编辑赛事项目
export function editProject(params) {
  return request({
    url: '/biz/item/edit',
    method: 'post',
		data: params
  })
}
// 删除赛事项目
export function delProject(id) {
  return request({
    url: `/biz/item/remove/${id}`,
    method: 'get',
  })
}


// 赛事----------------------------
// 赛事列表
export function gameList(query) {
  return request({
    url: '/biz/match/list',
    method: 'get',
    params: query
  })
}
// 赛事启用关闭
export function gameEdit(data) {
  return request({
    url: '/biz/match/editMatch',
    method: 'post',
    data
  })
}
// 赛事详情
export function gameInfo(params) {
  return request({
    url: `/biz/match/getInfo`,
    method: 'get',
    params
  })
}
// 赛事导出
// /biz/match/export
// 赛事审批
export function gameAudit(params) {
  return request({
    url: '/biz/match/editCheck',
    method: 'post',
		data: params
  })
}
// 删除赛事项目
export function gameDel(id) {
  return request({
    url: `/biz/match/remove?id=${id}`,
    method: 'get',
  })
}
// 成员列表
export function gameMember(query) {
  return request({
    url: '/biz/match/applyList',
    method: 'get',
    params: query
  })
}

//赛事举办/编辑
export function holdMatch(params) {
  return request({
    url: `/auth/match/editMacth`,
    method: 'post',
    isJson: true,
    data:params
  })
}